/* eslint-disable react/no-this-in-sfc */
import type { ChartOverlay, OverlayDataKind } from "components/charts/modern/overlay/types";
import PremiumPaywallPopover from "components/conversion/PremiumPaywallPopover";
import {
  FatSelectItem,
  Select,
  SelectContent,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "components/ui/Select";
import classNames from "components/ui/classNames";
import useSelfie from "lib/hooks/useSelfie";
import { FormattedMessage, useIntl } from "react-intl";

interface IChartOverlaySelectProps {
  value: OverlayDataKind | null;
  disabled?: boolean;
  onChange: (value: OverlayDataKind | null) => void;
  overlays: ChartOverlay[];
}

export default function ChartOverlaySelect({ value, onChange, overlays, disabled }: IChartOverlaySelectProps) {
  const selfie = useSelfie();
  const canUse = selfie ? selfie.isPremium : false;
  const intl = useIntl();
  const placeholder = intl.formatMessage({
    description: "Selecione eventos para aplicar no gráfico",
    defaultMessage: "Selecionar eventos",
    id: "qu4OGf",
  });

  return (
    <Select
      value={value || ""}
      onValueChange={(value) => onChange(value ? (value as OverlayDataKind) : null)}
      disabled={disabled || !canUse}
    >
      <PremiumPaywallPopover displayOrigin="Chart overlay select" isEnabled={!canUse}>
        <SelectTrigger
          className={classNames(
            "font-aeonik",
            "w-full rounded-lg sm:max-w-xs",
            "border border-slate-200 bg-white",
            "text-sm font-medium tracking-wide text-slate-600",
            "disabled:select-none",
            "hover:border-transparent hover:ring-4 hover:ring-slate-100 hover:ring-offset-1 hover:ring-offset-slate-300",
            "focus-visible:border-transparent focus-visible:ring-4 focus-visible:ring-indigo-100 focus-visible:ring-offset-1 focus-visible:ring-offset-indigo-300",
            "truncate",
          )}
        >
          <SelectValue placeholder={placeholder}>
            {value ? overlays.find((node) => node.kind === value)?.title : placeholder}
          </SelectValue>
        </SelectTrigger>
      </PremiumPaywallPopover>

      <SelectContent className="rounded-lg border border-slate-200 text-sm" side="top">
        <FatSelectItem className="cursor-pointer rounded-lg text-sm text-slate-600" value="">
          <FormattedMessage
            description="Nenhum evento selecionado para o gráfico"
            defaultMessage="Nenhum"
            id="uqqFGl"
          />
        </FatSelectItem>
        <SelectSeparator />
        {overlays.map((node) => {
          return (
            <FatSelectItem key={node.kind} className="cursor-pointer rounded-lg text-sm" value={node.kind}>
              <div className="space-y-1 font-aeonik">
                <h4 className="text-xs font-bold text-slate-600">{node.title}</h4>
                <p className="text-xs tracking-wide text-slate-500">{node.description}</p>
              </div>
            </FatSelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
